


export const DATETIME_OPTIONS = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
};

export const MIN_AMOUNT = 100
export const WITHDRAWAL_PERCENTAGE = 12
export const WITHDRAWAL_CHARGE_FEE = 20